/**
 * Sentinel value for the "All" option in select filters.
 *
 * Radix `Select` does not allow an empty-string item value, so dropdowns that
 * support an "All" / no-filter choice use this sentinel for that option and map
 * it back to "no filter" when handling the change.
 */
export const ALL_FILTER_VALUE = 'all';
